<div class="md:grid md:grid-cols-4 gap-6 mb-13 text-base font-medium sm:flex sm:flex-col">
    <ng-container *ngFor="let item of data; let index=index">
        <div class="text-white">
            <!--Titolo-->
            <a (click)="ckeckModifica()" class="font-semibold hover:underline" href="{{item.link}}"><mat-icon *ngIf="index < 3" class="mr-3 text-white"
                [svgIcon]="SVG_ICONS[index]"></mat-icon><span>{{item.title}}</span></a>

            <div class="border-b my-5"></div>

            <!--items-->
            <ng-container *ngFor="let sub of item.sub; let i = index">
                <div class="flew flex-row my-2">
                    <a (click)="ckeckModifica()" class="underline" href="{{sub.link}}">{{sub.title}}</a>
                </div>
            </ng-container>

        </div>
    </ng-container>
</div>


